module.exports = __webpack_public_path__ + "static/media/logowhite.544872cd.png";